module.exports = __webpack_public_path__ + "static/key-neoverse-8d88fe5b1dad27397b3d63790c19416c.webp";